import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import './index.scss';
import '../../assets/font/iconfont.css';
import {useTranslation} from "react-i18next";
import {Provider} from 'react-redux';
import {store} from '../../store';

export const EnaeaLayout = () => {
    const {t} = useTranslation();
    useEffect(() => {
        document.title = t('name');
    }, []);
    return <Provider store={store}>
        <div className={'enaea_layout'} data-theme={'default'}>
            <Outlet/>
        </div>
    </Provider>;
};

